import React, { useState } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { formatDate, formatTime } from '../../helpers/dateTime';
import SectionLoading from '../common/SectionLoading';
import { logUI } from "../../api/andyliticsApi";
import { Collapse } from 'reactstrap';
//import PatientName from '../estimates/patientName';


const DetailsDescriptionTile = props => {
    const {benefitDetails } = props;
    const bd = benefitDetails[0];
    const [showMessages, setShowMessages] = useState(false);
    //const payerInfoList = (quote && quote.payerInformation) ? quote.payerInformation : null;
    const appliedInsurances = (benefitDetails && bd.appliedInsurances) ? bd.appliedInsurances : null;
    const hasPayerInfo = appliedInsurances && appliedInsurances.length > 0;
    console.info(`DetailsDescriptionTile benefitDetails`, benefitDetails);

    try {

        if (benefitDetails.length > 0) {
            return <div className="row dtls-description-tile">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-8">
                                    <div className="card-heading">
                                        {bd.quoteName ? bd.quoteName : '' /*props.dashBoardDetails.Appointments.AppointmentType*/}
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="estimate-details-date-container">
                                        <div className="estimate-details-date">{formatDate(bd.dateOfService, { month: "short", day: "2-digit" })}</div>
                                        <div className="estimate-details-hour">{getTime(bd.dateOfService)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12 dtls-description-tile__body">
                                    <div className="row">
                                        <div className="col estimate-details-label">Patient:</div>{/*Once pulling actual related data pull from the benefitDetails*/}
                                        <div className="col estimate-details-text">{`${bd.patientInformation.firstName} ${bd.patientInformation.lastName}`}</div>
                                    </div>
                                    <div className="row appointment-info">
                                        <div className="col estimate-details-label">Hospital:</div>
                                        <div className="col estimate-details-text">{bd.providerInformation.facilityName}</div>
                                    </div>
                                    <div onClick={() => setShowMessages(!showMessages)} className="row estimate-details-tile-message showDetails">
                                        <div className="col-12">{showMessages} APPOINTMENT INFO <span className={showMessages ? "icon-dd-up" : "icon-dd"} /></div>
                                    </div>
                                    <Collapse isOpen={showMessages}>
                                        <div className="row appointment-info">
                                            <div className="col appointment-info-label">Account No:</div>
                                            <div className="col appointment-info-text">{(bd.environment && bd.environment.toLowerCase().indexOf('hospital') === -1) ? bd.csnId : bd.alternateAccountNumber}</div>
                                        </div>
                                        {(bd.procedurePricingDetails && bd.procedurePricingDetails[0] && bd.procedurePricingDetails[0].procedureDescription) &&
                                            <div className="row appointment-info">
                                                <div className="col appointment-info-label">Service:</div>
                                                <div className="col appointment-info-text">{bd.procedurePricingDetails.map(e => e.procedureDescription).filter((service,index,services)=> services.indexOf(service)===index).join(", ")}</div>
                                            </div>
                                        }
                                        {(bd.providerInformation && bd.providerInformation.tin) &&
                                            <div className="row appointment-info">
                                                <div className="col appointment-info-label">Tax ID Number:</div>
                                            <div className="col appointment-info-text">{bd.providerInformation.tin.replace(/\D/g, '').replace(/(\d{3})(\d{2})(\d{3})/g, '$1-$2-$3')}</div>
                                            </div>
                                        }
                                        {(bd.providerInformation && bd.providerInformation.npi) &&
                                            <div className="row appointment-info">
                                                <div className="col appointment-info-label">Provider ID Number:</div>
                                                <div className="col appointment-info-text">{bd.providerInformation.npi}</div>
                                            </div>
                                        }
                                        {(bd.providerInformation && bd.providerInformation.diagnosisCodes) &&
                                            <div className="row appointment-info">
                                                <div className="col appointment-info-label">Diagnosis Code:</div>
                                                <div className="col appointment-info-text">{bd.providerInformation.diagnosisCodes}</div>
                                            </div>
                                        }
                                    </Collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        } else {
            return <div className="row">
                <div className="col-12"><div className="card"><SectionLoading /></div></div>
            </div>;
        }
    } catch (ex) {
        //console.error(`detailsDescriptionTile exception`,ex);

        logUI("MBHWeb.UI.Estimates.detailsDescriptionTile", new Date(), `estimateDetails/${props.msgId}`, props, 'ERROR', ex.message);
        return <React.Fragment>{ex}</React.Fragment>
    }
}

const getTime = (dt) => {
    //if (dt.indexOf("+") != -1) {
    //    dt = dt.substring(0, dt.indexOf("+"));
    //}
    return formatTime(dt, { hour: "numeric", minute: "2-digit"});
}



export default DetailsDescriptionTile;